import React from 'react';
import type { AgentToolResult } from '../../../../core/ai/agent/IAgentTool';
import { Button } from '../../../../components/ui/button';
import { useDiagramStore } from '../../../../stores/diagramStore';
import { useUIStore } from '../../../../stores/uiStore';
import { useProcessViewStore } from '../../../../stores/processViewStore';
import { PROCESS_STEP_TYPES, getProcessStepDuration } from '../../utils/processDuration';

/** A local selection action. Actual field edits still use the property-panel command. */
export const ProcessDurationInputAction: React.FC<{ result: AgentToolResult; canWrite: boolean }> = ({ result, canWrite }) => {
  const nodes = useDiagramStore((state) => state.nodes);
  if (!canWrite || result.data?.needsInput !== true || result.data?.missingField !== 'duration') return null;
  const reportedIds = new Set(Array.isArray(result.data.stepIds)
    ? result.data.stepIds.filter((id): id is string => typeof id === 'string') : []);
  const missing = nodes.filter((node) => reportedIds.has(node.id)
    && PROCESS_STEP_TYPES.has(node.type) && getProcessStepDuration(node) === null);
  if (!missing.length) return <p className="text-xs text-muted-foreground">Duration estimates added. Ask for the critical path again.</p>;
  return (
    <Button
      variant="outline"
      size="sm"
      className="mt-2"
      onClick={() => {
        const state = useDiagramStore.getState();
        if (!state.canWrite) return;
        // Recheck after the click; an old chat result must not select deleted or completed steps.
        const step = state.nodes.find((node) => reportedIds.has(node.id)
          && PROCESS_STEP_TYPES.has(node.type) && getProcessStepDuration(node) === null);
        if (!step) return;
        state.setSelected(new Set([step.id]));
        useProcessViewStore.getState().setPropertyPanelEditMode(true);
        const ui = useUIStore.getState();
        ui.setPropertyPanelUserClosed(false);
        ui.setPropertyPanelTab('data');
        ui.setPropertyPanelOpen(true);
        ui.setActivePanel('properties');
      }}
    >
      Edit durations ({missing.length} remaining)
    </Button>
  );
};
